export class BackendValidationError extends Error {
	get axios() {
		return this.#errors
	}
	#errors
	constructor(errors: { description: string }[]) {
		super(errors[0].description)
		this.#errors = errors
		this.name = 'BackendValidationError'

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, BackendValidationError)
		}
	}
}
